import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-429">
      {visible && <motion.a href="#pricing" initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="md:hidden fixed bottom-3 left-3 right-3 z-50 bg-primary text-black font-space-grotesk font-extrabold text-base text-center py-3.5 rounded-2xl shadow-[0_10px_30px_rgba(249,168,212,0.45)] active:scale-[0.98] transition-transform" data-id="element-430">
          🍑 QUIERO MI PLAN →
        </motion.a>}
    </AnimatePresence>;
}